import * as Yup from 'yup';

export const replyYopValidation = () => {
  return Yup.object().shape({
    reply: Yup.string().required('required'),
  });
};
